import type { CouncilCost } from '../../types/council';

const NEAR_CAP_FRACTION = 0.9;

export function computeSpendDisplay(cost?: CouncilCost | null):
  { used: number; cap: number; frac: number; breaches: number; barColor: string } | null {
  if (!cost || !cost.cost_cap_usd_per_day) return null;
  const used = parseFloat(cost.cost_used_usd);
  const cap = parseFloat(cost.cost_cap_usd_per_day);
  const breaches = (cost.overshoot_events ?? []).length;
  const frac = Number.isFinite(used) && Number.isFinite(cap) && cap > 0 ? Math.min(1, used / cap) : 0;
  const barColor = breaches > 0 ? 'bg-red-500' : frac >= NEAR_CAP_FRACTION ? 'bg-amber-500' : 'bg-emerald-500';
  return { used, cap, frac, breaches, barColor };
}
